import * as React from 'react';
import { DefaultTheme } from './DefaultTheme';
export const ThemeContext = /*#__PURE__*/React.createContext(DefaultTheme);
ThemeContext.displayName = 'ThemeContext';
//# sourceMappingURL=ThemeContext.js.map